'use client';

import { useState } from 'react';
import { Button, type ButtonProps } from '@material-bank/mb3-components';
import { triggerFileDownload } from './triggerFileDownload';
type DownloadButtonProps = Omit<ButtonProps, 'onClick'> & {
  downloadFn: () => Promise<Blob>;
  fileName?: string;
};

// A button that runs an async download function and saves the resulting blob
// to the user's device, managing its own loading state. Adapted from
// mb3-frontend (logs failures instead of using mb3-frontend's browserLogger).
export function DownloadButton({
  downloadFn,
  fileName,
  disabled,
  children,
  ...buttonProps
}: DownloadButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false);
  async function clickHandler() {
    if (isDownloading || disabled) {
      return;
    }
    setIsDownloading(true);
    try {
      const blob = await downloadFn();
      triggerFileDownload(blob, fileName ?? 'download');
    } catch (error) {
      console.error('Failed to download file', error);
    } finally {
      setIsDownloading(false);
    }
  }
  return <Button disabled={isDownloading || disabled} onClick={clickHandler} {...buttonProps}>
      {children}
    </Button>;
}